import { render, staticRenderFns } from "./DialogNoteDetails.vue?vue&type=template&id=fee9d292&scoped=true"
import script from "./DialogNoteDetails.js?vue&type=script&lang=js&external"
export * from "./DialogNoteDetails.js?vue&type=script&lang=js&external"
import style0 from "./DialogNoteDetails.vue?vue&type=style&index=0&id=fee9d292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9d292",
  null
  
)

export default component.exports